<script setup>
/** @typedef {import('@/models/Todo').Todo} Todo */
import { ref, onMounted, computed } from 'vue';
import InputTodo from '@/components/todo/InputTodo.vue';
import ResultTodo from '@/components/todo/ResultTodo.vue';
import DeletedList from '@/components/todo/DeletedList.vue';
import { useTodos } from '@/composables/useTodos.js';

const {
  todos,
  isLoadingTodo,
  processingId,
  fetchTodos,
  addTodo,
  updateTodo,
  toggleCompletedTodo,
  removeTodo,
} = useTodos();

// 表示モード管理
const showMode = ref('all');

// 表示用の削除済みTODOリスト
const deletedTodos = computed(() => {
  return todoList.value.filter((todo) => todo.deletedAt);
});
// 表示用のtodoList。配列に変換済み
const todoList = computed(() => {
  return [...todos.value.values()];
});
// フィルタリングされたTODOリスト
const filteredTodos = computed(() => {
  if (showMode.value === 'active') {
    return todoList.value.filter((todo) => !todo.completedAt && !todo.deletedAt);
  } else if (showMode.value === 'completed') {
    return todoList.value.filter((todo) => todo.completedAt && !todo.deletedAt);
  } else {
    return todoList.value.filter((todo) => !todo.deletedAt);
  }
});

// ページロード時（コンポーネントマウント時）に呼び出す
onMounted(() => {
  fetchTodos(); // これでComposable側の関数が呼ばれます
});
</script>

<template>
  <!-- @add 子から受け取ったイベント -->
  <InputTodo @add="addTodo" />
  <!-- @remove 子から受け取ったイベント
        filteredTodos はcomutedで定義
    -->
  <div class="grid grid-cols-3 items-center justify-around gap-5 my-5">
    <button
      type="button"
      class="cursor-pointer bg-blue-500 text-white px-4 py-2 rounded"
      @click="showMode = 'all'"
    >
      すべて表示
    </button>
    <button
      type="button"
      class="cursor-pointer bg-amber-500 text-white px-4 py-2 rounded"
      @click="showMode = 'active'"
    >
      未完了だけ
    </button>
    <button
      type="button"
      class="cursor-pointer bg-green-500 text-white px-4 py-2 rounded"
      @click="showMode = 'completed'"
    >
      完了だけ
    </button>
  </div>

  <ResultTodo
    :isLoading="isLoadingTodo"
    :processingId="processingId"
    :todos="filteredTodos"
    @remove="removeTodo"
    @update="updateTodo"
    @completed="toggleCompletedTodo"
  />

  <h3 class="text-2xl mt-10">削除済み</h3>
  <DeletedList :deleted-todos="deletedTodos" @remove="removeTodo" />
</template>
